// extracted by mini-css-extract-plugin
export default {"Error":"MDxneAqp9HhHtGsmPiQE"};